import React from "react";

const FAQSection = () => {
  return (
    <section className="bg-[#03173f] py-12 px-8">
      <div className="max-w-[1800px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        <div>
          <h2 className="text-[32px] md:text-[52px] font-normal text-white leading-tight">
            Frequently Asked Questions
          </h2>

          <p className="mt-2 text-[18px] md:text-[24px] text-gray-300 leading-relaxed">
            Find answers to common questions about our services, features, and
            support.
          </p>
        </div>

        <button
          onClick={() => window.open("/Konn3ctFaqs", "_blank")}
          className="bg-[#2657B0] text-white font-bold text-[16px] md:text-[20px] rounded-3xl h-[40px] md:h-[60px] w-full max-w-[180px]"
        >
          VIEW FAQs
        </button>
      </div>
    </section>
  );
};

export default FAQSection;